<script>
    import OPTS from '../../libs/options';
    export let fondi = []; // [{ title: "", id: "" }]
    export let selected;

    function goToFondo(webid) {
        if (!OPTS.change_page_on_fondo)
            return;

        window.location.href = webid === ''
            ? `${window.contextPath}/ricerca.html`
            : `${window.contextPath}/ricerca/${webid}.html`
    }
</script>
<div class="c-funds-filter">
    <div class="c-funds-filter__mobile-button">
        <button id="funds-filter-open-panel"
                class="c-funds-filter__panel-button c-funds-filter__panel-button--open">
            <span>Scegli il fondo</span>
            <i class="fas fa-chevron-right"></i>
        </button>
    </div>
    <div class="c-funds-filter__panel">
        <div class="c-funds-filter__mobile-button">
            <button id="funds-filter-close-panel"
                    class="c-funds-filter__panel-button c-funds-filter__panel-button--close">
                <i class="fas fa-chevron-left"></i>
                <span>Scegli il fondo</span>
            </button>
        </div>
        <div class="c-funds-filter__panel-body">
            <div class="c-funds-filter__all-funds">
                <div class="c-funds-filter__label">Guarda tutti i fondi:</div>
                <div class="c-funds-filter__inputs">
                    <div class="c-funds-filter__input-item">
                        <input name="fund" type="radio" bind:group={selected} on:click={(it) => goToFondo('')} id="all-funds" value="all"/>
                        <label for="all-funds">Tutti i fondi</label>
                    </div>
                </div>
            </div>
            <div class="c-funds-filter__funds">
                <div class="c-funds-filter__label">Scegli il fondo:</div>
                <div class="c-funds-filter__inputs">
                    {#each fondi as fondo (fondo.id)}
                        <div class="c-funds-filter__input-item">
                            <input name="fund" bind:group={selected} on:click={(it) => goToFondo(fondo.webid)} type="radio" id="fondo-{fondo.id}" value="{fondo.id}"/>
                            <label for="fondo-{fondo.id}">{fondo.title}</label>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>
